<template>
    <div class="column is-three-quarters right-side theme-style">
        <gallery-box v-bind:lot="lot"></gallery-box>
        <div class="columns">
            <div class="column is-paddingless is-fullheight">
                <bid-box v-bind:lot="lot"></bid-box>
            </div>
        </div>
        <div class="other-section" v-if="!isMobile">
            <translate-box v-bind:lot="lot"></translate-box>
            <comments-box v-bind:lot="lot"></comments-box>
        </div>
    </div>
</template>

<script>
    import GalleryBox from './GalleryBox'
    import BidBox from './BidBox'
    import CommentsBox from './CommentsBox.vue'
    import InlandCost from '../../Tools/Calculators/InlandCost.vue'
    import TranslateBox from './Details/TranslationBox'
    import CarSpecs from './Details/CarSpecs'
    import AucInfo from './Details/AucInfo'

    export default {
        props: ['lot'],
        components: {
            galleryBox: GalleryBox,
            bidBox: BidBox,
            commentsBox: CommentsBox,
            InlandCost,
            TranslateBox,
            CarSpecs,
            AucInfo
        },
        computed: {
            isMobile() {
                return document.documentElement.clientWidth < 450;
            }
        }
    }
</script>

<style scoped>
    .column {
        max-width: 100%;
    }

    .columns {
        margin-left: 0;
        margin-right: 0;
        margin-top: 0;
        margin-bottom: 0;
    }
</style>




// WEBPACK FOOTER //
// src/components/Auctions/Lot/RightSide.vue